import React from 'react';
import {ConstraintDataPlugin, ConstraintPluginProps} from '../ConstraintDataPlugin';
import {
    ConstraintType,
    DataTypeConstraintDto,
    RegExConstraintDataDto
} from '../../../../../../common/apis/datatype/DataTypeConstraintDto';
import {CoreDataType} from "../../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {RegExConstraintPluginForm} from "./RegExConstraintPluginForm";
import {CommonTranslation} from "../../../CommonTranslation";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {ConstraintValueValidationPlugin} from "../ConstraintValueValidationPlugin";
import {TranslationFunction} from "../../../../../../store/localization/TranslMessasge";

export class RegExConstraintPlugin implements ConstraintDataPlugin<RegExConstraintDataDto>, ConstraintValueValidationPlugin {
    readonly type = ConstraintType.REGULAR_EXPRESSION;

    getSupportedDataTypes(): CoreDataType[] {
        return [
            CoreDataType.STRING, CoreDataType.INTEGER, CoreDataType.FLOAT, CoreDataType.CURRENCY
        ];
    }

    getInitialData(): RegExConstraintDataDto {
        return {
            type: ConstraintType.REGULAR_EXPRESSION,
            regEx: '^.+$'
        };
    }

    render(props: ConstraintPluginProps<RegExConstraintDataDto>): React.ReactElement {
        return <RegExConstraintPluginForm {...props} />;
    }

    validate(data: RegExConstraintDataDto, coreDataType: CoreDataType): Record<string, string> {
        const errors: Record<string, string> = {};

        if (!data.regEx) {
            errors.regEx = CommonTranslation.FILL_OUT_THIS_FIELD;
        } else {
            try {
                new RegExp(data.regEx);
            } catch (e) {
                errors.regEx = DataTypeTranslationKey.REGULAR_EXPRESSION_IS_INVALID;
            }
        }

        return errors;
    }

    getConstraintExpression(data: RegExConstraintDataDto): string {
        return data.regEx || "";
    }

    validateValue(value: any, attributeId: string, constraint: DataTypeConstraintDto, t: TranslationFunction): Record<string, string> {
        // TODO: will be implemented as a part of the following task AR-2057
        return {};
    }
}
